import { render, staticRenderFns } from "./IFRPDFRatios.vue?vue&type=template&id=4b1ef83a"
import script from "./IFRPDFRatios.vue?vue&type=script&lang=js"
export * from "./IFRPDFRatios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports